/**
 * Created by stonewang on 2017/8/28.
 */
import {config, request, objectSerial} from 'Utils';


/**
 * 组织改变
 * @param param
 * */
export function changOrg(param) {
    return request(`${config.server}/api/v1/dms/login/changeOrg?${objectSerial(param)}`, {method: 'post'});
}

/**
 * 账号密码登录
 * @param param
 * */
export function login(param) {
    return request(`${config.server}/api/v1/dms/login/userLogin?${objectSerial(param)}`, {method: 'post'});
}

/**
 * 短信验证码登录
 * @param param
 * */
export function loginCode(param) {
    return request(`${config.server}/api/v1/dms/login/phoneLogin`, {
        method: 'post',
        search: param
    });
}

/**
 * 退出登录
 * @param param
 * */
export function logout(param) {
    return request(`${config.server}/api/v1/dms/login/logout`);
}

/**
 * 消息 首页
 * @param param
 * @returns {*}
 */
export function getMessageHome() {
    return request(`${config.server}/api/v1/dms/message/listByPC?p=1&s=4`);
}

/**
 * 消息 列表
 * @param param
 * @returns {*}
 * ajax 问号拼接请求：
 export function fetchCustomModulesList(param) {
    return request(`${config.server}/api/v1/dms/dmsTgChannel/searchByCus${objectSerial(param)}`, {
        method: 'get'
    });
}
 */
export function getMessageList(param) {
    return request(`${config.server}/api/v1/dms/message/listByPC?${objectSerial(param)}`);
}

/**
 * 消息 设置消息已读
 * @param param
 * @returns {*}
 */
export function setMessageRead(ids) {
    return request(`${config.server}/api/v1/dms/message/read`, {
        method: 'post',
        body: ids
    });
}

/**
 * 消息 设置消息已读
 * @param param
 * @returns {*}
 */
export function messageSearch(ids) {
    return request(`${config.server}/api/v1/dms/message/search`, {
        method: 'post',
        body: ids
    });
}

/**
 * 增值税发票 详情
 * @param id
 * @returns {*}
 */
export function getInvoiceDetail(id) {
    return request(`${config.server}/api/v1/dms/invoice/detail?id=${id}`, {
        method: 'get'
    });
}

/**
 * 增值税发票 审批
 * @param id
 * @returns {*}
 */
export function getInvoiceApprove(param) {
    return request(`${config.server}/api/v1/dms/invoice/audit`, {
        method: 'post',
        body: param
    });
}

/**
 * 账号 审批
 * @param param
 * @returns {*}
 */
export function getAccountDetail(id) {
    return request(`${config.server}/api/v1/dms/user/getUserDetailById?id=${id}`, {
        method: 'get'
    });
}

/**
 * 产品销量 Top5
 * @param param
 * @returns {*}
 */
export function getProductTop5(searchType) {
    return request(`${config.server}/api/v1/dms/reportForms/getTop5ByPC?searchType=${searchType}`, {
        method: 'get'
    });
}

/**
 * 订单 数量\金额 统计
 * @param param
 * dateType 2\3\4 月\季\年
 * searchType 1\2 金额\数量
 * @returns {*}
 */
export function getOrderReport(searchType, dateType) {
    return request(`${config.server}/api/v1/dms/reportForms/getOrderInfoByPC?searchType=${searchType}&dateType=${dateType}`, {
        method: 'get'
    });
}

/**
 * 产品销量 Top5
 * @param param
 * @returns {*}
 */
export function getNoMessageCount(searchType) {
    return request(`${config.server}/api/v1/dms/common/cornerMark`, {
        method: 'get'
    });
}

/**
 * 自定义快捷方式 客戶保存的列表
 * @param param
 * @returns {*}
 */
export function fetchCustomModulesList() {
    return request(`${config.server}/api/v1/mxm/knResource/search`, {
        method: 'get'
    });
}

/**
 * 自定义快捷方式 插件的左边数据
 * @param param
 * @returns {*}
 */
export function fetchLeftSideList() {
    return request(`${config.server}/api/v1/mxm/knResource/selectByRoleId`, {
        method: 'get'
    });
}

/**
 * 自定义快捷方式 保存自定义快捷方式接口
 * @param param
 * @returns {*}
 */
export function saveModules(param) {
    return request(`${config.server}/api/v1/mxm/knResource/saveUserMenu`, {
        method: 'post',
        body: param
    });
}

/**
 * 渠道列表
 * @param param
 * @returns {*}
 */
export function fetchChannelList(param) {
    return request(`${config.server}/api/v1/dms/homePage/channel`, {
        method: 'get'
    });
}

/**
 * 渠道列表
 * @param param
 * @returns {*}
 */
export function fetchAllChannelList(param) {
    return request(`${config.server}/api/v1/dms/homePage/channelAll`, {
        method: 'get'
    });
}

/**
 * 渠道列表
 * @param param
 * @returns {*}
 */
export function fetchAllBusinessLineList(param) {
    return request(`${config.server}/api/v1/dms/homePage/businessLineAll`, {
        method: 'get'
    });
}

/**
 * 角色判断
 * @param param
 * @returns {*}
 */
export function checkRole() {
    return request(`${config.server}/api/v1/mxm/knResource/resources`, {
        method: 'get'
    });

}

/**
 * 授信情况
 * @param param
 * @returns {*}
 */
//http://192.168.31.46:8180/xweb/api/v1/dms/dmsErpCredit/gdCredit
export function credit(param) {
    return request(`${config.server}/api/v1/dms/dmsErpCredit/gdCredit`, {
        method: 'post',
        body: param
    });
}

/**
 * 基本消息
 * @param param
 * @returns {*}
 */
export function besic(param) {
    return request(`${config.server}/api/v1/dms/homePage/basicMeg`, {
        method: 'post',
        body: param
    });
}

/**
 * 修改密码
 * @param param
 * @returns {*}
 */
export function modifyPassword(param) {
    return request(`${config.server}/api/v1/dms/user/updatePsw`, {
        method: 'post',
        search: param
    });
}

/**
 * 修改手机号发送验证码
 * @param param
 * @returns {*}
 */
export function getModifyPhoneCode(param) {
    return request(`${config.server}/api/v1/common/sendShortMessage/sendMsg`, {
        method: 'post',
        body: param
    });
}

/**
 * 修改手机号
 * @param param
 * @returns {*}
 */
export function modifyPhone(param) {
    return request(`${config.server}/api/v1/dms/employee/updatePhone`, {
        search: param
    });
}

/**
 * 短信登录发送验证码
 * @param param
 * @returns {*}
 */
export function getLoginPhoneCode(param) {
    return request(`${config.server}/api/v1/common/sendShortMessage/sendLoginCode`, {
        method: 'post',
        body: param
    });
}

export function getQrCodeLogin(param) {
    return request(`${config.server}/api/v1/dms/login/scanLogin`, {
        method: 'post',
        search: param
    });
}

/**
 * 获取未参与的问卷调查
 * @returns {*}
 */
export function getUnJoin() {
    return request(`${config.server}/api/v2/DmsResearch/listByUnJoin`, {
        method: 'post'
    });
}

/**
 * 消息提醒
 * @param param
 * @returns {*}
 */
export function getConfirmMessage(param) {
    return request(`${config.server}/api/v1/dms/message/confirmList`, {
        method: 'post',
        body: param
    });
}

/**
 * 附件下载
 * @param {id} id
 * @returns
 */
export function getFileDown(id) {
    return `${config.server}/api/v1/dms/commonAttachUpload/getFileDown?id=${id}`
}

/******************* 商品选型库 start *********************/
/**
 * 消息 列表 APP
 * @param param
 * @returns {*}
 */
export function getMsgListByApp(param) {
    return request(`${config.server}/api/v1/dms/message/listByApp`, {
        method: 'post',
        body: param
    });
}

/**
 * 获取委托书模版
 * @returns {*}
 */
export function getProxyTemplate(param) {
    return request(`${config.server}/api/v2/dms/invoice/getProxyTemplate`, {
        method: 'get',
        body: param
    });
}

/******************* 商品选型库 end *********************/



// WEBPACK FOOTER //
// ./src/service/home/index.js